/**
 * Résout une URL publique pour un fichier legacy (uploads/…).
 * Les photos employés restent servies depuis le domaine demo / legacy, pas l'API.
 */
export function resolveLegacyUploadUrl(relativePath: string | null | undefined): string | null {
  const raw = relativePath?.trim();
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw)) return raw;

  const normalized = raw.replace(/^\/+/, "");
  const assetsBase = import.meta.env.VITE_LEGACY_ASSETS_URL?.replace(/\/$/, "");
  if (assetsBase) {
    return `${assetsBase}/${normalized}`;
  }

  if (typeof window !== "undefined") {
    const basePath = (import.meta.env.VITE_BASE_PATH ?? "/").replace(/\/$/, "");
    const origin = window.location.origin;
    return `${origin}${basePath}/${normalized}`;
  }

  return `/${normalized}`;
}
